module.exports = __webpack_public_path__ + "img/Indacoin-logo.bafc77e3.png";